module.exports={render:function (){
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "custom-class": "lease-renew-form-dialog lease-dialog",
      "visible": _vm.show,
      "title": "续租"
    },
    on: {
      "open": _vm.handleOpen,
      "update:visible": function (flag) { return this$1.$emit('update:show', flag); }
    }
  }, [_c('el-form', {
    attrs: {
      "label-position": "top"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "订单类型"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "订单类型"
    },
    model: {
      value: (_vm.form.RentalOrderType),
      callback: function($$v) {
        _vm.form.RentalOrderType = $$v
      },
      expression: "form.RentalOrderType"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "固定租期",
      "value": "inflexibleTerm"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "灵活租期",
      "value": "flexibleTerm"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    attrs: {
      "data": _vm.list
    }
  }, [_c('el-table-column', {
    attrs: {
      "label": "批次号",
      "width": "170px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(props.row.LotCode))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物料名称/编码",
      "width": "260px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('p', {
          staticClass: "no-margin"
        }, [_vm._v(_vm._s(props.row.ProductName))]), _vm._v(" "), _c('p', {
          staticClass: "no-margin"
        }, [_vm._v("物料编码：" + _vm._s(props.row.ProductCode))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "物料品项",
      "width": "170px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-tag', {
          attrs: {
            "type": _vm._f("ConditionColor")(props.row.ConditionName)
          }
        }, [_vm._v(_vm._s(props.row.ConditionName))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "租赁周期",
      "width": "170px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(props.row.RentalPeriod) + "个月")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "折扣",
      "width": "170px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(props.row.DiscountRate * 100) + "%")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "原租金",
      "width": "170px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm._f("amount")(props.row.RentalAmount)))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "已租天数",
      "width": "170px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(Math.round(props.row.RentDays)) + "天")]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "保修",
      "width": "200px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-select', {
          model: {
            value: (_vm.Products[props.$index].WarrantyDays),
            callback: function($$v) {
              _vm.Products[props.$index].WarrantyDays = $$v
            },
            expression: "Products[props.$index].WarrantyDays"
          }
        }, _vm._l((_vm.WarrantyOptions[props.$index]), function(WarrantyOption) {
          return _c('el-option', {
            key: WarrantyOption.PeriodInDays,
            attrs: {
              "value": WarrantyOption.PeriodInDays,
              "label": ("￥" + (WarrantyOption.UnitPriceAmount) + "/" + (WarrantyOption.PeriodInDays) + "天")
            }
          })
        }))]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "续租时间",
      "width": "160px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_c('el-select', {
          model: {
            value: (_vm.Products[props.$index].RentalPeriodInDays),
            callback: function($$v) {
              _vm.Products[props.$index].RentalPeriodInDays = $$v
            },
            expression: "Products[props.$index].RentalPeriodInDays"
          }
        }, [_c('el-option', {
          attrs: {
            "value": 90,
            "label": "3个月"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "value": 180,
            "label": "6个月"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "value": 360,
            "label": "12个月"
          }
        }), _vm._v(" "), _c('el-option', {
          attrs: {
            "value": 540,
            "label": "18个月"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "续租单价",
      "width": "140px"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(props) {
        return [_vm._v(_vm._s(_vm._f("amount")(props.row.RentalAmount)))]
      }
    }])
  })], 1), _vm._v(" "), _c('span', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('span', {
    staticClass: "count"
  }, [_vm._v("续租数量：" + _vm._s(this.list.length) + "个")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.handleConfirm()
      }
    }
  }, [_vm._v("提交并等待客服联系")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-21bf0f21"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/Lease/RenewFormDialog.vue
// module id = 706
// module chunks = 0